import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Permissions from "./pages/Permissions";
// import Role from "./pages/Role/Role";

// import CreateUser from "./pages/user/CreateUser";
// import ViewUser from "./pages/user/ViewUser";

import Login from "./pages/login/Login";
import { AuthProvider, useAuth } from "./context/Authcontext";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./ProtectedRoute";
import DashboardLayout from "./pages/DashboardLayout";
import Home from "./pages/Home";
import Role from "./pages/role/Role";
import CreateUserForm from "./pages/user/createUser";
import ViewUser from "./pages/user/ViewUser";
import CreateTenant from "./pages/tenant/CreateTenant";
import TenantCardView from "./pages/tenant/TenantView";
import CompanyCreateForm from "./pages/company/CreateCompany";
import ViewCompany from "./pages/company/ViewCompany";
import TenantDashboardLayout from "./pages/Dashboard/TenantDashboardLayout";
import CompanyDashboardLayout from "./pages/Dashboard/CompanyDashboardLayout";
import CreateServicePage from "./pages/services/CreateService";
import ServiceListView from "./pages/services/ViewServiceList";
import CreateInventory from "./pages/Inventory/CreateInventory";
import CreateOrder from "./pages/order/CreateOrder";
import ViewOrders from "./pages/order/ViewOrder";
import ViewInventory from "./pages/Inventory/ViewInventory";
import CompanyRevenueReport from "./pages/reports/CompanyRevenueReport";
import TenantRevenueReport from "./pages/reports/TenantRevenueReport";
import CompanyDashBoardHome from "./pages/Dashboard/CompanyDashBoardHome";
import PayrollDistribution from "./pages/salery/DistributePayrole";
import StaffReport from "./pages/reports/StaffReport";
import TenantHome from "./pages/home/TenantHome";
import GeneralSettingsPage from "./pages/settings/SettingsPage";
import LocationManagement from "./pages/location/Location";
import DiscountsSection from "./pages/Discount/DiscountSection";
import AddExpensePage from "./pages/expenses/AddexpensesPage";
import ExpenseReport from "./pages/expenses/expenseReport";
import PlanManagement from "./pages/plans/planManagement";
import MemberManagement from "./pages/member/memberManagement";
import CompanyUsers from "./pages/company/CompanyUsers";

export default function Approutes() {
  const { checkRolePresent, currentRole } = useAuth();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute allowedRoles={["superAdmin"]}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="/user/createuser" element={<CreateUserForm />} />
        <Route path="/user/viewUser" element={<ViewUser />} />
        <Route path="/tenant/create" element={<CreateTenant />} />
        <Route path="/tenant/view" element={<TenantCardView />} />
        <Route path="/company/create" element={<CompanyCreateForm />} />

        <Route path="/company/view" element={<ViewCompany />} />
        <Route path="role" element={<Role />} />
        <Route
          path="/reports/companyRevenue"
          element={<CompanyRevenueReport />}
        />
        <Route path="reports/staffReport" element={<StaffReport />} />

        <Route
          path="/reports/tenantRevenue"
          element={<TenantRevenueReport />}
        />
        <Route path="/location" element={<LocationManagement />} />
      </Route>

      {/* 🏢 TENANT ROUTES */}
      <Route
        path="/tenant/:tenantId"
        element={
          <ProtectedRoute allowedRoles={["tenantAdmin", "superAdmin"]}>
            <TenantDashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<TenantHome />} />
        <Route path="settings" element={<GeneralSettingsPage />} />

        <Route path="service/create" element={<CreateServicePage />} />
        <Route path="service/view" element={<ServiceListView />} />
        <Route path="service/view" element={<ServiceListView />} />
        <Route path="user/createuser" element={<CreateUserForm />} />
        <Route path="user/viewUser" element={<ViewUser />} />
        <Route path="company/create" element={<CompanyCreateForm />} />
        <Route path="company/view" element={<ViewCompany />} />
        <Route
          path="reports/companyRevenue"
          element={<CompanyRevenueReport />}
        />
        <Route path="reports/staffReport" element={<StaffReport />} />
        <Route path="discount" element={<DiscountsSection />} />

        <Route path="reports/tenantRevenue" element={<TenantRevenueReport />} />
        <Route path="reports/expenseReport" element={<ExpenseReport />} />

        {/* <Route index element={<TenantDashboard />} />
        <Route path="users" element={<TenantUsers />} />
        <Route path="companies" element={<TenantCompanyList />} /> */}
      </Route>

      {/* 🏭 COMPANY ROUTES */}
      <Route
        path="/company/:companyId"
        element={
          <ProtectedRoute
            allowedRoles={["companyAdmin", "tenantAdmin", "superAdmin"]}
          >
            <CompanyDashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<CompanyDashBoardHome />} />
        <Route path="user/createuser" element={<CreateUserForm />} />
        <Route path="user/viewUser" element={<ViewUser />} />
        <Route path="service/create" element={<CreateServicePage />} />
        <Route path="service/view" element={<ServiceListView />} />

        <Route path="inventory/create" element={<CreateInventory />} />
        <Route path="inventory/view" element={<ViewInventory />} />

        <Route path="order/create" element={<CreateOrder />} />
        <Route path="order/view" element={<ViewOrders />} />
        <Route path="distributePay" element={<PayrollDistribution />} />
        <Route path="discount" element={<DiscountsSection />} />
        <Route path="expense" element={<AddExpensePage />} />
        <Route path="reports/expenseReport" element={<ExpenseReport />} />
        <Route path="plans" element={<PlanManagement />} />
        <Route path="members" element={<MemberManagement />} />
        <Route path="users" element={<CompanyUsers />} />
        <Route path="settings" element={<GeneralSettingsPage />} />

        {/* <Route index element={<CompanyDashboard />} />
        <Route path="inventory" element={<CompanyInventory />} />
        <Route path="employees" element={<CompanyEmployeeList />} /> */}
      </Route>

      {/* </Route> */}
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}
